__turbopack_context__.v({
  "className": "poppins_85a0d8c0-module__mFdrda__className",
  "variable": "poppins_85a0d8c0-module__mFdrda__variable",
});
